class Storage {
    get(key) {
        return localStorage.getItem(key);
    }
    set(key, value) {
        return localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
    }
    remove(key) {
        return localStorage.removeItem(key);
    }
    getJSON(key) {
        return JSON.parse(this.get(key) || 'null');
    }
    setJSON(key, value) {
        return this.set(key, JSON.stringify(value));
    }
}
export default new Storage();



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Storage.ts
// module id = 39
// module chunks = 0